import { readonly, validateStandardSchema } from '@angular/forms/signals';

import type { GridEntity } from '@sites/entity-core';
import { DefaultGridEntitySchema } from '@sites/entity-core';

import type { BaseEntityFormOptions } from '../../core/create-base-entity-form';
import { createBaseEntityForm } from '../../core/create-base-entity-form';

export type GridFormModel = GridEntity;
export type GridDataModel = GridEntity['props'];

export type GridForm = ReturnType<typeof createGridForm>;

export function createGridForm(options?: BaseEntityFormOptions<GridEntity>) {
    const base = createBaseEntityForm<GridEntity>((schemaPath) => {
        validateStandardSchema(schemaPath, DefaultGridEntitySchema.latestSchema);
        readonly(schemaPath.id);
        readonly(schemaPath.entityType);
        readonly(schemaPath.entitySubType);
        readonly(schemaPath.version);
    }, options);

    const { _raw } = base;

    return {
        ...base,

        get children() {
            return _raw.children;
        },
        updateChildren: (updater: (current: string[][]) => string[][]) => {
            _raw.children().value.update((current) => updater(current as string[][]));
        },

        get variant() {
            return _raw.props.variant;
        },
        setVariant: (value: GridDataModel['variant']) => {
            _raw.props.variant().value.set(value);
        },

        get rowCellWidth() {
            return _raw.props.rowCellWidth.desktop;
        },
        updateRowCellWidth: (updater: (value: number[][]) => number[][]) => {
            _raw.props.rowCellWidth.desktop().value.update(updater);
        },

        // Gap X
        get gapXValue() {
            return _raw.props.gapX.desktop.value;
        },
        setGapX: (value: number) => {
            _raw.props.gapX.desktop().value.set({ value, unit: 'px' });
        },

        // Gap Y
        get gapYValue() {
            return _raw.props.gapY.desktop.value;
        },
        setGapY: (value: number) => {
            _raw.props.gapY.desktop().value.set({ value, unit: 'px' });
        },
    };
}
